import React from "react";
import { Box, Tooltip, alpha } from "@mui/material";

const StatusIcon = ({ icon, active, color, tooltip }) => (
  <Tooltip title={tooltip} arrow>
    <Box
      sx={{
        p: 0.6,
        borderRadius: "8px",
        bgcolor: active ? alpha(color, 0.1) : "#f1f5f9",
        color: active ? color : "#cbd5e1",
        display: "flex",
        transition: "0.2s",
      }}
    >
      {React.cloneElement(icon, { sx: { fontSize: 16 } })}
    </Box>
  </Tooltip>
);

export default StatusIcon;